import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable, timer } from 'rxjs';
import { delay, take, tap, timeout } from 'rxjs/operators';
import { EnvService } from 'src/app/_servicos/env.service';

import { Aplicacao } from './../_classes/aplicacao';

@Injectable({
  providedIn: 'root',
})
export class AplicacaoService {
  //private baseUrl = '';
  private headers: HttpHeaders = new HttpHeaders();
  private configUrl = '';
  private _appFront: Aplicacao = new Aplicacao();
  private _appBack: Aplicacao = new Aplicacao();
  temErro: boolean = false;
  carregando: boolean = false;
  erroString: string = '';
  t: any;

  public resposta = '';

  private delay = 0;
  private timeout = 15000;

  constructor(private env: EnvService, private http: HttpClient) {
    this.configUrl = 'assets/config/aplicacao.json';
    this.headers.append('Content-Type', 'application/json');
    this.carregarVersao();
  }

  public getApiUrl(): string {
    return `${this.env.apiUrl}`;
  }

  public get appFront(): Aplicacao {
    return this._appFront;
  }

  public get appBack(): Aplicacao {
    return this._appBack;
  }

  getAplicacao(): Observable<Aplicacao> {
    //console.log('getAplicacao()');
    this.temErro = false;
    this.erroString = '';
    return this.http
      .get<Aplicacao>(this.getApiUrl() + '/geral/public/versao', {
        headers: this.headers,
      })
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        //tap(console.log),
        take(1)
      );
  }

  public carregarVersao() {
    //console.log('carregarVersao()');
    this.temErro = false;
    this.erroString = '';
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
      }
    });

    //carrega versão do front
    //console.log('carregarLocal');
    this.http.get<Aplicacao>(this.configUrl).subscribe({
      next: (data: Aplicacao) => {
        //console.log('carregarLocal(retorno)', data);
        this._appFront = Aplicacao.createInstance(data);
      },
      error: (e) => {
        // console.log('Erro ao buscar dados do servidor', e);
        //this.erroServidor = true;
        return EMPTY;
      },
      complete: () => {
        //console.log('complete');
        //this.carregando = false;
      },
    });

    //carrega versão do back
    //console.log('carregarRemoto');
    this.http
      .get<Aplicacao>(this.getApiUrl() + '/geral/public/versao', {
        headers: this.headers,
      })
      .subscribe({
        next: (data: Aplicacao) => {
          //console.log('carregarRemoto(retorno)', data);
          this._appBack = Aplicacao.createInstance(data);
        },
        error: (e) => {
          //console.log('carregarRemoto(retorno-erro)');
          //console.log('Erro ao buscar dados do servidor', e);
          this.temErro = true;
          this.erroString = e.message;
          return EMPTY;
        },
        complete: () => {
          //console.log('carregarRemoto(retorno-complete)');
          //console.log('complete carregarVersao');
          this.carregando = false;
        },
      });
  }
}
